
import React, { useState, useEffect } from "react";
import SlidingPanel from 'react-sliding-side-panel';
import CommunityImg from '../../Common/CommunityImg/CommunityImg';
import { default as badge } from '../../../images/eco-alliance-badge.svg';
import Filter from '../../Common/Filter/Filter';
import { orderBy } from 'lodash';
import { INDUSTRY_CHOICES, COUNTRY_LIST, ECO_COUNTRY_LIST } from '../../../utils/const';
import 'react-sliding-side-panel/lib/index.css';
import './EcoAllianceSlidePanel.scss';

const EcoAllianceSlidePanel = ({
  isOpen,
  onClose,
  location,
  blogsList
}) => {
  const [openPanel, setOpenPanel] = useState(false);
  const [searchStr, setSearchStr] = useState('');
  const [locationStr, setLocationStr] = useState('');
  const [isMobile, setIsMobile] = useState(false);
  const [update, setUpdate] = useState(false);
  const [countryList, setCountryList] = useState([]);
  
  const [filteredList, setFilteredList] = useState(blogsList);
  const country_list_obj = [];

  useEffect(() => {
    if (isOpen) {
      generateCountryList();
      filterInitialBlogList();
      setOpenPanel(true);
      document.body.parentElement.style.overflow = 'hidden';
      if (window.innerWidth < 768) setIsMobile(true);
    } else {
      document.body.parentElement.style.overflow = 'auto';
      setIsMobile(false);
    }
  }, [isOpen, location]);

  const capitalize = str => {
    return str === 'USA' ? 'USA' : str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }

  const generateCountryList = () => {
    ECO_COUNTRY_LIST.forEach(item => {
      const newCountry = item.replace('#', '');
      const obj = { name: capitalize(newCountry), key: item };
      country_list_obj.push(obj);
    });
    setCountryList(orderBy(country_list_obj, 'name'));
    setUpdate(!update);
  }

  const filterInitialBlogList = () => {
    const {country} = location;
    setLocationStr(country);

    const tempBlogList = [...blogsList].filter(ele => {
      const idx = ele.node.tags.findIndex(innerEle => {
        if(country.toLowerCase() === 'usa') {
          return innerEle.name.toLowerCase() == 'usa' || innerEle.name == '#UNITED STATES OF AMERICA';  
        } else {
          return innerEle.name.toLowerCase() == country.toLowerCase() || innerEle.name.toLowerCase() == `#${country.toLowerCase()}`;
        }
      });
      return idx !== -1 ? ele : null;
    });
    setFilteredList(tempBlogList);
  }

  const onRequestClose = () => {
    setOpenPanel(false);
    onClose();
  }

  const onFilter = (item) => {
    setSearchStr('');
    const [selectedFilter] = INDUSTRY_CHOICES.filter(ele => ele.label === item);
    const { key } = selectedFilter;

    const tempBlogList1 = [...blogsList].filter(ele => {
      const idx = ele.node.tags.findIndex(innerEle => innerEle.name.toLowerCase().includes(locationStr.toLowerCase()));
      return idx !== -1 ? ele : null;
    });

    const tempBlogList = tempBlogList1.filter(ele => {
      const idx = ele.node.tags.findIndex(innerEle => innerEle.slug === key);
      return idx !== -1 ? ele : null;
    });

    setFilteredList(tempBlogList);
  }

  const onSearchEventPartner = (e) => {
    const { target: { value } } = e;
    setSearchStr(value);
  }

  const onFilterLocation = (item) => {

    const [selectedFilter] = countryList.filter(ele => ele.name === item);
    const { key } = selectedFilter;
    setLocationStr(key);
    const tempBlogList = [...blogsList].filter(ele => {
      const idx = ele.node.tags.findIndex(innerEle => {
        if(key.toLowerCase() === 'usa') {
          return innerEle.name.toLowerCase() == 'usa' || innerEle.name == '#UNITED STATES OF AMERICA';  
        } else {
          return innerEle.name.toLowerCase() == key.toLowerCase() || innerEle.name.toLowerCase() == `#${key.toLowerCase()}`;
        }
      });
      return idx !== -1 ? ele : null;
    });

    setFilteredList(tempBlogList);
  }

  return (
    <SlidingPanel
      type={'right'}
      isOpen={openPanel}
      size={isMobile ? 100 : 70}
      backdropClicked={onRequestClose}
      panelContainerClassName={`eco-alliance-left-overlay-container ${isMobile ? 'mobile' : 'web'}`}
      panelClassName="eco-alliance-left-overlay"
    >
      <div className="eco-alliance-slider-container">
        <i
          className={`fa fa-close close-btn`}
          style={{ fontSize: '20px' }}
          onClick={onRequestClose}
          role="presentation"
        >
        </i>
        <div className="eco-alliance-slider-header">
          <CommunityImg className="eco-alliance-slider-header-img" role="presentation" alt="badge" src={badge} />
          <div className="eco-alliance-slider-header-content">
            <span className="content-subheading">Our Eco-Alliance Members in</span>
            <div className="content-heading">
              {/* {location.location} */}
              <Filter
                cls='eco-alliance-slider-filter header'
                width={400}
                defaultSelection={location.country}
                filterData={countryList.map(item => item.name)}
                onSelect={onFilterLocation}
              />
            </div>
          </div>
          <CommunityImg className="eco-alliance-slider-header-img" role="presentation" alt="badge" src={badge} />
        </div>
        <div className="eco-alliance-slider-content">
          <div className="eco-alliance-slider-content-header">
            <Filter
              cls='eco-alliance-slider-filter'
              title="Industry"
              width={380}
              filterData={INDUSTRY_CHOICES.map(item => item.label)}
              onSelect={onFilter}
            />
            <div className="search-text-box">
              <input
                value={searchStr}
                type="text" id="fname"
                name="fname"
                placeholder="search members..."
                onChange={onSearchEventPartner}
              />
            </div>
          </div>
          <div className="eco-alliance-slider-content-item-list">
            {
              searchStr.length ?
                ([...filteredList.filter(item => item.node.title.toLowerCase().includes(searchStr.toLowerCase()))]).map((blogItem, idx) => {
                  return <ContentItem key={idx} blogItem={blogItem.node} />
                })
                :
                [...filteredList].map((blogItem, idx) => {
                  return <ContentItem key={idx} blogItem={blogItem.node} />
                })
            }
          </div>
        </div>
      </div>
    </SlidingPanel>
  );
};

const ContentItem = (blog) => {

  const [url, setURL] = useState('');

  useEffect(()=>{
    const [arr, link] = blog.blogItem.url.split('ghost.noissue.co');
    setURL(link);
  }, [blog]);

  const openLink = () => {
    window.open(`https://noissue.co/blog${url}`, '_blank', 'noopener');
  }

  return <div className="content-item">
    <CommunityImg 
      src={blog.blogItem.feature_image} 
      alt="slider pic" 
      role="presentation" 
    />
    <div className="content-item-details">
      <div className="heading"> {blog.blogItem.title} </div>
      <div className="sub-heading"> {blog.blogItem.excerpt}</div>
      <button className="content-button" onClick={openLink}>Read Brand Story</button>
      {/* <div className="content-learn-more">
        <span>Learn more</span>
        <i
          className={`fa fa-facebook social-media-svg`}
          style={{ fontSize: '15px' }}>
        </i>
        <i
          className={`fa fa-instagram social-media-svg`}
          style={{ fontSize: '15px' }}>
        </i>
      </div> */}

    </div>
  </div>
}

export default EcoAllianceSlidePanel;

